module.exports = __webpack_public_path__ + "img/cp6-2.e264b2a5.jpg";